import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';
import { EnergyDiagram } from '../energy-diagram/EnergyDiagram';
import { HeatingTypeSelector } from '../atomic-components/HeatingTypeSelector';
import { CarbonEmissionTextField } from '../atomic-components/CarbonEmissionTextField';
import { EnergyEmissionTextField } from '../atomic-components/EnergyEmissionTextField';
import { PropertySellingPointsTextField } from '../atomic-components/PropertySellingPointsTextField';
import { PropertyDetailsTextField } from '../atomic-components/PropertyDetailsTextField';

interface Props {
  disabled: boolean;
}

export const AssetEnergyDemand: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<POST_WITH_ID>();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.propertydetails.title')}>
      <PropertyDetailsTextField disabled={disabled} />
      <PropertySellingPointsTextField disabled={disabled} />
      <div>
        <Typography gutterBottom variant="h6">
          {t('dashboard.assets.addedit.main.energydemand.title')}
        </Typography>
        <HeatingTypeSelector disabled={disabled} />
        <EnergyEmissionTextField disabled={disabled} />
        <CarbonEmissionTextField disabled={disabled} />
        {/* TODO: These values can be undefined in the form if you want to remove them */}
        <EnergyDiagram
          energyLevel={formik.values.propertyDetails?.energyEmission || 0}
          co2Emission={formik.values.propertyDetails?.carbonEmission || 0}
        />
      </div>
    </LaunchpadCard>
  );
};
